import PropTypes from 'prop-types';


// Bootstrap 4 style close button ("x" inside .close), the modal styles are
// written for it (reactstrap 9 renders the Bootstrap 5 .btn-close instead).
const ModalCloseButton = ({ onClick }) => (
  <button
    type="button"
    className="close"
    aria-label="Close"
    onClick={onClick}
  >
    <span aria-hidden="true">&times;</span>
  </button>
);

ModalCloseButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default ModalCloseButton;
